import React from 'react';
import { ReactComponent as Icon } from 'App/assets/img/heart.svg';
import { Button } from '@welbe/design-system';
import { Container, TextSpan } from './ManageProfileButton.styles';

export const ManageProfileButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<Container>
			<Button
				variant="outline"
				id="button-candidate-profile"
				width="240px"
				onClick={onClick}
			>
				<TextSpan>
					Perfiles de estudios <Icon />
				</TextSpan>
			</Button>
		</Container>
	);
};
